












































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { ValidationObserver } from 'vee-validate';
import { RootState } from '@/store/store';
import BaseModal from '@/jbi-shared/vue-components/BaseModal.vue';
import InviteUserForm, {
  InviteUserFormValues
} from '@/views/AdminUserManagement/components/InviteUserForm.vue';
import { isDifferent, isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import { InviteUserToProductPayload } from '@/store/modules/admin/types/admin.types';

@Component({
  components: {
    BaseModal,
    InviteUserForm,
    ValidationObserver
  }
})
export default class InviteUserButton extends Vue {
  @Prop() public products!: object;

  @Action('admin/inviteNewUserToProduct')
  public inviteNewUserToProduct!: (payload: InviteUserToProductPayload) => void;

  @State(
    (state: RootState) => state.admin.apiState.inviteNewUserToProduct.loading
  )
  public inviteNewUserToProductLoading!: boolean;
  public inviteNewUserSubmitButton: boolean = true;

  public handleInviteUser(values: InviteUserFormValues) {
    const { email, username, firstName, lastName, productId } = values;
    this.inviteNewUserToProduct({
      email,
      firstName,
      lastName,
      productId
    });
  }
  public handleSubmitButtonDisabledChange(newValue: boolean) {
    this.inviteNewUserSubmitButton = newValue;
  }
}
